import React, { useState } from 'react';
import { FaCheckCircle, FaRocket, FaSpinner } from 'react-icons/fa';
import { CONTACT } from '../constants/contact';
import './ContactForm.css';

const WEB3FORMS_KEY = 'f3622f40-7261-4f2c-9728-92274c85929a';

export default function ContactForm({
  className = '',
  title = 'Get Your Free Part Quote',
  subtitle = 'Fill out the form and our team will get back to you quickly.',
  titleId,
  showHeader = true,
}) {
  const [status, setStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus('');

    const formData = new FormData(e.target);
    formData.append('access_key', WEB3FORMS_KEY);
    formData.append('subject', 'MaxAutoParts — Part quote request');

    try {
      const response = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        body: formData,
      });
      const data = await response.json();

      if (data.success) {
        setStatus('success');
        e.target.reset();
      } else {
        setStatus('error');
      }
    } catch {
      setStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const rootClass = ['contact-form-glass', className].filter(Boolean).join(' ');

  if (status === 'success') {
    return (
      <div className={rootClass}>
        <div className="form-success">
          <FaCheckCircle className="success-icon" />
          <h4>Request Received!</h4>
          <p>Our experts are looking up your part now. We will be in touch shortly.</p>
        </div>
      </div>
    );
  }

  return (
    <div className={rootClass}>
      {showHeader && (title || subtitle) && (
        <>
          {title && (
            <h3 id={titleId}>{title}</h3>
          )}
          {subtitle && <p className="form-subtitle">{subtitle}</p>}
        </>
      )}

      <form onSubmit={handleSubmit} className="premium-form">
        <div className="cf-row">
          <input type="text" name="name" placeholder="Full Name" required />
          <input type="tel" name="phone" placeholder={CONTACT.phone} required />
        </div>
        <input type="email" name="email" placeholder="Email Address" required />
        <div className="cf-row">
          <input
            type="text"
            name="vehicle"
            placeholder="Year and Make (e.g. 2019 Toyota)"
            required
          />
          <input type="text" name="model" placeholder="Model (e.g. Camry)" required />
        </div>
        <textarea
          name="message"
          placeholder="Describe the part you are looking for..."
          rows={3}
          required
        />

        {status === 'error' && (
          <p className="form-error">Something went wrong. Please try again or call us.</p>
        )}

        <button type="submit" className="cf-submit" disabled={isSubmitting}>
          {isSubmitting ? (
            <FaSpinner className="spinner-icon" />
          ) : (
            <>
              <FaRocket className="cf-submit-icon" /> Get Instant Quote
            </>
          )}
        </button>

        <p className="cf-note">Fast response guaranteed during business hours.</p>
      </form>
    </div>
  );
}
